<template>
  <div class="relative w-full md:min-h-screen overflow-hidden flex items-center">
    <div class="container xl:max-w-[1440px] mx-auto flex gap-6 flex-col">
      <div class="flex justify-end items-center">
        <e-appearance
          color="neutral"
          variant="ghost"
        />
        <e-button
          color="neutral"
          icon="translate"
          variant="ghost"
        />
      </div>

      <section
        class="bg-(--color-card) rounded-2xl w-full md:p-20 mx-auto md:grid md:grid-cols-2 gap-0 md:gap-20"
      >
        <div class="flex flex-col items-start h-full">
          <e-logo
            class="w-[132px] h-auto mb-6"
            color="primary"
          />
          <div class="w-full flex-1 flex items-center justify-center">
            <slot name="image" />
          </div>
        </div>
        <slot />
      </section>

      <div class="flex flex-wrap justify-between gap-4">
        <e-copyright class="text-xs text-primary" />
        <p class="text-xs">
          <slot name="trailing" />
        </p>
      </div>
    </div>
  </div>
</template>
